import { render, staticRenderFns } from "./InputOrder.vue?vue&type=template&id=113f9e5a&"
import script from "./InputOrder.vue?vue&type=script&lang=js&"
export * from "./InputOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports